"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const useProgressBar_1 = __importDefault(require("./useProgressBar"));
const ProgressBarStyles = (0, styled_components_1.createGlobalStyle)(({ theme }) => ({
    '#nprogress': {
        /* Make clicks pass-through */
        pointerEvents: 'none',
        '.bar': {
            position: 'fixed',
            zIndex: 1031,
            top: 0,
            left: 0,
            width: '100%',
            background: theme === null || theme === void 0 ? void 0 : theme.colors.primary,
            height: '3px',
        },
        /* Fancy blur effect */
        '.peg': {
            position: 'absolute',
            right: 0,
            width: '100px',
            height: '100%',
            boxShadow: theme
                ? `0 0 10px ${theme.colors.primary}, 0 0 5px ${theme.colors.primary}`
                : undefined,
            opacity: 1,
            transform: 'rotate(3deg) translate(0px, -4px)',
        },
        '&:after': {
            content: '""',
            position: 'fixed',
            width: '100%',
            height: '3px',
            top: 0,
            backgroundColor: '#ffffff',
            zIndex: 999,
            boxShadow: '0 0px 14px #ffffff, 0 0px 7px #ffffff',
        },
        '.spinner,.spinner-icon': {
            display: 'none',
        },
    },
}), ({ theme }) => {
    var _a;
    return ({
        '#nprogress': (_a = theme === null || theme === void 0 ? void 0 : theme['loading']) === null || _a === void 0 ? void 0 : _a['progressBar'],
    });
});
function ProgressBar() {
    (0, useProgressBar_1.default)();
    return react_1.default.createElement(ProgressBarStyles, null);
}
exports.ProgressBar = ProgressBar;
//# sourceMappingURL=ProgressBar.js.map